<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <vs-tab icon-pack="feather" icon="icon-list" :label="!isSmallerScreen ? $t(`DATASOURCEVIEW.listOrigens`) : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <origin-list/>
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? $t(`DATASOURCEVIEW.uploadOrigin`) : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <origin-load/>
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-send" :label="!isSmallerScreen ? $t(`DATASOURCEVIEW.conecctions`) : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
       <Connections/>
      </div>
    </vs-tab>

  </vs-tabs>
</template>

<script>
import OriginList from './OriginList';
import OriginLoad from './OriginLoad';
import Connections from './Connections.vue';

export default {
  components: {
    OriginList,
    OriginLoad,
    Connections
  },
  data () {
    return {
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
